<template>
  <v-app-bar
    app
    color="indigo"
    clipped-left
    class="app-bar"
  >
    <v-app-bar-nav-icon
      class="app-bar-nav-icon"
      @click="$emit('appBarIconClicked')"
    />

    <v-toolbar-title
      class="toolbar-title"
    >
      Tom Colarusso
    </v-toolbar-title>
    <div
      class="icon-container d-none d-sm-flex"
    >
      <v-icon
        class="icon"
      >
        mdi-run-fast
      </v-icon>
      <v-icon
        class="icon"
      >
        mdi-weight-lifter
      </v-icon>
      <v-icon
        class="icon"
      >
        mdi-camera
      </v-icon>
      <v-icon
        class="icon gray-color"
      >
        mdi-cat
      </v-icon>
      <v-icon
        class="icon orange-color"
      >
        mdi-cat
      </v-icon>
    </div>
    <v-spacer />
    <v-switch
      v-model="darkMode"
      class="dark-mode-switch"
    >
      <label slot="label">
        Dark Mode
      </label>
    </v-switch>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppBar',
  computed: {
    darkMode: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(darkMode) {
        this.$vuetify.theme.dark = darkMode;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  $text-color: #E8EAF6;
  .gray-color {
    color: rgb(192, 191, 191);
  }
  .orange-color {
    color: orange;
  }
  .theme--light {
    color: $text-color;
  }
  .v-toolbar {
    .dark-mode-switch {
      &.v-input {
        margin-top: 20px;
      }
      &.theme--light {
        label {
          color: $text-color;
        }
        ::v-deep .v-input--switch__track.theme--light {
          background-color: $text-color;
        }
      }
    }
  }
  .app-bar {
    .app-bar-nav-icon {
      &.v-btn {
        color: $text-color;
      }
    }
    .icon {
      margin-left: 10px;
    }
  }
</style>
